module.exports = {"svg":{"$":{"class":"icon","width":"200px","height":"200.00px","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg"},"path":[{"$":{"d":"M63.3 512.2a448.5 448 0 1 0 897 0 448.5 448 0 1 0-897 0Z","fill":"#4D6BFF"}},{"$":{"d":"M416.09375 605.09375c1.21875 0.5625 2.15625 1.5 2.71875 2.71875l82.3125 175.6875c3.1875 6.84375 12.84375 7.03125 15.75 0.375l201.84375-465.75c3.5625-8.15625-4.78125-16.5-12.9375-12.9375L240.125 507.03125c-6.75 2.90625-6.5625 12.5625 0.375 15.75l175.59375 82.3125z","fill":"#ffffff"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/daohang.svg
// module id = 7lgt
// module chunks = 0